import Ad from "../gpt/Ad";

/**
 * Holds relationships between ads for the purpose
 * of refreshing them in tandem
 */
export default class CompanionGroup {

    private _parent: Ad | null = null;
    private _children: Ad[] = [];

    /**
     * Returns array of ads that are companioned to the parent.
     */
    children() {
        return this._children;
    }

    /**
     * Returns all Ads that are a part of the companion group.
     */
    members() {
        return Array.prototype.concat(this._parent, this._children);
    }

    /**
     * Returns the parent ad of the parent/children companion pair.
     */
    parent() {
        return this._parent;
    }

    /**
     * Sets the parent ad in the parent/children relationship.
     */
    addParent(ad: Ad) {
        this._parent = ad;
        ad.setCompanionGroup(this);
    }

    /**
     * Adds a child to the array of children ads in
     * the parent/children relationship.
     */
    addChild(ad: Ad) {
        if (this._children.lastIndexOf(ad) < 0) {
            this._children.push(ad);
            ad.setCompanionGroup(this);
        }
    }

    /**
     * Removes all children.
     */
    clearChildren() {
        this._children = [];
    }

    /**
     * Removes the parent.
     */
    clearParent() {
        this._parent = null;
    }

}
